import React, { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import "../index.css";

const Login = () => {
  const location = useLocation();
  console.log(location.pathname, '>>>>>>>>>>>>>>>>>>>>>>kkkk>>>>>>>>>>>>>');
  return (
    <Fragment>
      <div id="notfound">
        <div className="notfound">
          <div className="notfound-404">
            <h1>
              4<span>0</span>4
            </h1>
          </div>
          <div className="notfound-404">
            <h2>the page you requested could not found</h2>
          </div>
          <Link className="loginButton" to="/">
            Back To Home
          </Link>
        </div>
      </div>
    </Fragment>
  );
};
export default Login;
